import { History } from "history";

export let history: History;

export function setHistory(h: History): void {
  history = h;
}
